import { useEffect, useState } from 'react';
export function useQueryStringParams(key) {
    const [param, setParam] = useState('');
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        setParam(params.get(key) || '');
    }, []);
    return param;
}
